import {
  INCOME_GROUP_LABELS,
  type IncomeGroup,
  incomeGroupSchema,
  type HistoryYear,
} from '#shared/types';

/** The ways the income screen can group, in the order the control offers them. */
export const INCOME_GROUP_OPTIONS = incomeGroupSchema.options.map((value) => ({
  value,
  label: INCOME_GROUP_LABELS[value],
}));

/**
 * The grouping named in the URL, or by day.
 *
 * Matched against the allowed values rather than cast: a hand-edited or stale
 * link must not put an unknown grouping into the request or index the label
 * map with it.
 */
export function parseIncomeGroup(raw: string | null): IncomeGroup {
  return INCOME_GROUP_OPTIONS.find((option) => option.value === raw)?.value ?? 'day';
}

/**
 * The surplus as a whole-number percentage of what was billed, or null when
 * nothing was.
 *
 * Against *billed*, not collected: the margin is a property of the work done
 * in the period, and an unsettled balance is a collection problem rather than
 * a profitability one.
 */
export function marginPercent(surplus: number, billed: number): number | null {
  return billed > 0 ? Math.round((surplus / billed) * 100) : null;
}

/** Visits and tests summed across every year of the history. */
export function sumHistoryYears(years: readonly HistoryYear[]): {
  patients: number;
  reports: number;
} {
  return years.reduce(
    (sum, year) => ({
      patients: sum.patients + year.patients,
      reports: sum.reports + year.reports,
    }),
    { patients: 0, reports: 0 },
  );
}
